import { profile } from "console";
import CommonSideDialog from "../../../../../../common/components/side-dialog/CommonSideDialog";
import { StaffReportResponse } from "../../../../../../model/safety/staff-report";
import { formatTimestamp } from "../../../../../../utils";
import styles from "./ReportedStaffSideDialog.module.scss";

type Props = {
	staffReport: StaffReportResponse;
	onCloseDialog: () => void;
};

const ReportedStaffSideDialog: React.FC<Props> = (props: Props) => {
	return (
		<CommonSideDialog onCloseDialog={props.onCloseDialog}>
			<div className={styles.sideDialogContent}>
				<div className={styles.headerContent}>
					<h2 className={styles.title}>Reported Staff</h2>
					<button className={styles.closeBtn} onClick={() => props.onCloseDialog()}>
						×
					</button>
				</div>

				<div className={styles.imageContainer}>
					{!props.staffReport.fileUrl ? (
						<>
							<div className={styles.emptyImage} />
							<span className={styles.emptyImageText}>No Image Uploaded</span>
						</>
					) : (
						<img src={props.staffReport.fileUrl} alt="Reported Staff" className={styles.uploadedImage} />
					)}
				</div>

				<div className={styles.detailsHeader}>
					<span className={styles.headerText}>Incident Details</span>
					<div className={styles.reportTypeContainer}>
						<div className={styles.circle} />
						<span className={styles.reportTypeText}>{props.staffReport.reason.name}</span>
					</div>
				</div>

				<div className={styles.detailsContainer}>
					<div className={styles.detailRow}>
						<span className={styles.label}>Staff Name</span>
						{props.staffReport.staffInfo ? (
							<span className={styles.value}>{props.staffReport.staffInfo.name}</span>
						) : (
							<div className={styles.notAvailableContainer}>NA</div>
						)}
					</div>
					<div className={styles.detailRow}>
						<span className={styles.label}>Staff ID</span>
						<span className={styles.value}>{props.staffReport.staffId}</span>
					</div>
					<div className={styles.detailRow}>
						<span className={styles.label}>Report Initiated By</span>
						<span className={styles.value}>{props.staffReport.customerName}</span>
					</div>
					<div className={styles.detailRow}>
						<span className={styles.label}>Date & Time</span>
						<span className={styles.value}>{formatTimestamp(props.staffReport.createdAt ?? "")}</span>
					</div>
				</div>

				<div className={styles.descriptionWrapper}>
					<span className={styles.descriptionLabel}>Description</span>
					<div className={styles.descriptionContainer}>{props.staffReport.description ? props.staffReport.description : "NA"}</div>
				</div>
			</div>
		</CommonSideDialog>
	);
};

export default ReportedStaffSideDialog;
